import React, {useContext, useEffect, useState} from 'react';
import {Tabs} from 'antd';
import {sideMenuContext} from '../../../router/IndexRouter';
import {Arguments} from './Arguments';

const CustomTabs = () => {
	const {sideMenu, setSideMenu, openKeys, setOpenKeys} = useContext(sideMenuContext);
	const [activeKey, setActiveKey] = useState('');
	const [items, setItems] = useState(sideMenu);

	const onChange = (key) => {
		// 被点击的 Tab 被选中，且高亮显示
		setActiveKey(key);
		// 将当前选中的 Tab 所对应的左侧一级菜单打开
		if (openKeys[0] !== key.split('/')[1]) {
			setOpenKeys(['/' + key.split('/')[1]]);
		}
	};

	const remove = (targetKey) => {
		const targetIndex = items.findIndex(pane => pane.key === targetKey);
		const newPanes = items.filter(pane => pane.key !== targetKey);
		if (newPanes.length > 0 && targetKey === activeKey) {
			const {key} = newPanes[targetIndex === newPanes.length ? targetIndex - 1 : targetIndex];
			// 同时打开最新 activeKey 所对应的页面，实现了关闭标签后关闭标签所对应页面的效果
			window.open(Arguments.reactUrl + key, '_self');
			setActiveKey(key);
		}
		setItems(newPanes);
		// 当关闭某些 Tab 后，应该同步更新 sideMenu， 同时去 SideMenu.js 中更新 tipMenuList
		// 避免再次点击左侧菜单后依然使用旧的数据更新 sideMenu，使得关闭的 Tab 又再次出现
		setSideMenu(newPanes);
	};

	const onEdit = (targetKey, action) => {
		if (action === 'remove') {
			remove(targetKey);
		}
	};

	// 默认情况下，最后一个 Tab（即最新打开的页面的 Tab）高亮显示，当在表单页面刷新时不能报错，因此使用 ?.key
	useEffect(() => {
		const lastTabKey = items.length > 0 ? items[items.length - 1]?.key : '';
		const currentUrl = window.location.hash.replace('#', '');
		setItems(sideMenu);
		if (currentUrl === lastTabKey) {
			setActiveKey(lastTabKey);
		}
	}, [sideMenu, items]);

	return (
		<Tabs
			hideAdd
			animated={true}
			onChange={onChange}
			onTabClick={path => window.open(Arguments.reactUrl + path, '_self')}
			destroyInactiveTabPane={true}
			activeKey={activeKey}   // 高亮显示的 tab: '/society/member-personal'
			type={items.length > 1 ? 'editable-card' : 'card'}    // tab 中是否有删除按钮
			onEdit={onEdit}
			items={items}
		/>
	);
};

export default CustomTabs;
